export const LANGUAGE_LIST_SUCCESS = "LANGUAGE_LIST_SUCCESS";
export const LANGUAGE_LIST_FAIL = "LANGUAGE_LIST_FAIL";